<div class="region-exceptions-header">
  <span class="title">{{ 'region-exceptions-title' | transloco }}</span>
  <span class="subtitle">{{ 'region-exceptions' | transloco }}</span>
</div>
<app-checkbox-accordion
  [regionList]="regionList"
  [formGroup]="formGroup"
></app-checkbox-accordion>
